import { createSingleEntityStore, type PickActions } from '@core/ngrx-legacy';

import type { AssistantConfig } from './assistant-config.http';

const {
  reducer: AssistantConfigReducer,
  actions,
  selectors: AssistantConfigSelectors,
  namespace: AssistantConfigNamespace,
} = createSingleEntityStore<AssistantConfig>()('AssistantConfig');

const AssistantConfigActions: PickActions<typeof actions, 'fetch'> = actions;

export {
  AssistantConfigActions,
  AssistantConfigReducer,
  AssistantConfigSelectors,
  AssistantConfigNamespace,
};
